import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "../../lib/api";

export const DonorWall = () => {
  const [names, setNames] = useState([]);
  useEffect(() => { api.get("/bethea/donors").then((r) => setNames(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="mt-6 rounded-2xl border border-white/10 bg-[#000099]/50 p-5" data-testid="donor-wall">
      <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase font-semibold text-[#ECC23D]">
        <Heart className="w-3.5 h-3.5 text-[#F02078]" /> Donor Wall · With Gratitude
      </div>
      {names.length === 0 ? (
        <p className="text-sm text-white/80 mt-3" data-testid="donor-wall-empty">Be the first name on our wall of gratitude for House of Bethea.</p>
      ) : (
        <ul className="mt-3 flex flex-wrap gap-2">
          {names.map((n) => (
            <li key={n} data-testid="donor-wall-name" className="px-3 py-1.5 rounded-full border border-[#D4AF37]/40 text-sm text-white font-serif">{n}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
